import { Fragment } from "react";
import { Grid } from "@mui/material";

import TransactionList from "./List";
import { ActiveTextEighteen } from "../css components/Style";
import Pagination from "../../components/Pagination";

export default function Transaction({ creditInfo, page, setPage, lastPage }) {
  function handlePagination(step, index) {
    setPage((prev) =>
      step === "index" ? index : prev + (step === "next" ? 1 : -1)
    );
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} style={{ marginTop: "12px" }}>
        <ActiveTextEighteen>All Transaction Details</ActiveTextEighteen>
      </Grid>

      {creditInfo.creditHistory.length > 0 ? (
        <Fragment>
          <Grid item xs={12}>
            <TransactionList creditInfo={creditInfo} />
          </Grid>

          {parseInt(lastPage.totalCount) > 0 && (
            <Grid item container display={"flex"} justifyContent={"center"}>
              <Pagination
                count={Math.ceil(lastPage.totalCount / 10)}
                variant="outlined"
                color="secondary"
                page={page}
                onChange={(e, value) => handlePagination("index", value)}
              />
            </Grid>
          )}
        </Fragment>
      ) : (
        <Grid item xs={12} textAlign={"center"}>
          <ActiveTextEighteen style={{ fontSize: "16px", marginTop: "20px" }}>
            No Transactions found.
          </ActiveTextEighteen>
        </Grid>
      )}
    </Grid>
  );
}
